import { render, staticRenderFns } from "./DrawMoneyTips.vue?vue&type=template&id=4701cef8&scoped=true"
import script from "./DrawMoneyTips.vue?vue&type=script&lang=js"
export * from "./DrawMoneyTips.vue?vue&type=script&lang=js"
import style0 from "./DrawMoneyTips.vue?vue&type=style&index=0&id=4701cef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701cef8",
  null
  
)

export default component.exports